import { PageState } from "@/components/layout/PageState";

/** A failed route permission read is retryable; never mount protected children or infer denial. */
export function AccessLoadError({ onRetry }: { onRetry: () => void }) {
  return <main id="main-content" className="min-h-screen bg-background p-4 lg:p-8">
    <div className="mx-auto max-w-2xl space-y-4">
      <h1 className="text-2xl font-semibold text-foreground">Couldn't verify your permissions</h1>
      <PageState kind="error" title="Access check failed"
        description="Nothing was changed. Try again to verify your access before opening this page." onRetry={onRetry} />
    </div>
  </main>;
}
